import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProductCard from './ProductCard';
import ProductUpdate from './ProductUpdate';

/**
 * Affiche le composant ProductCard pour chaque produit
 * de la commande actuelle
 * @param {Object[]} items Tous les produits présent dans une commande
 */
const ProductsTab = ({ items, commandState }) => {
  const isUpdatable = [
    'draft',
    'picking_required',
    'out_of_stock',
    'picking_paused'
  ].includes(commandState);
  return (
    <div style={{ paddingBottom: 40 }}>
      {!isUpdatable && (
        <div>
          {items.map(item => (
            <ProductCard
              key={item.id}
              item={item}
              commandState={commandState}
            />
          ))}
        </div>
      )}
      {isUpdatable && <ProductUpdate />}
    </div>
  );
};

const mapStateToProps = state => ({
  items: state.commands.currentCommand.items,
  commandState: state.commands.currentCommand.state
});

ProductsTab.propTypes = {
  items: PropTypes.array.isRequired,
  commandState: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(ProductsTab);
